export type RegistryUrlScalar = string | number | boolean | null | undefined;
export type RegistryUrlValues = Record<string, RegistryUrlScalar | RegistryUrlScalar[]>;

const FORBIDDEN_KEYS = new Set([
  "role", "roles", "scope", "systemscope", "datascope", "owneruserid", "userid",
  "currentuserid", "warehouseids", "allowedwarehouseids", "allowedorganizationids",
  "limit", "offset", "page", "pagesize", "cursor", "token", "password", "secret",
]);

function normalizedKey(value: string) {
  return value.replace(/[^a-z0-9]/gi, "").toLocaleLowerCase("en-US");
}

function safeKey(value: string) {
  return /^[A-Za-z][A-Za-z0-9_.-]{0,95}$/.test(value) && !FORBIDDEN_KEYS.has(normalizedKey(value));
}

export function readRegistryUrlState(prefix: string, allowedKeys: readonly string[]): Record<string, string | string[]> {
  if (!safeKey(prefix)) return {};
  const allowed = new Set(allowedKeys.filter(safeKey));
  const query = window.location.hash.split("?", 2)[1] || "";
  const params = new URLSearchParams(query);
  const result: Record<string, string | string[]> = {};
  for (const key of allowed) {
    const values = params.getAll(`${prefix}.${key}`).filter((value) => value.length <= 512 && !/[\u0000-\u001f]/.test(value));
    if (values.length === 1) result[key] = values[0]!;
    else if (values.length > 1) result[key] = values;
  }
  return result;
}

export function writeRegistryUrlState(prefix: string, values: RegistryUrlValues): void {
  if (!safeKey(prefix)) return;
  const [rawPath, rawQuery = ""] = window.location.hash.replace(/^#\/?/, "").split("?", 2);
  const path = rawPath || "dashboard";
  const params = new URLSearchParams(rawQuery);
  for (const key of [...params.keys()]) {
    if (key.startsWith(`${prefix}.`)) params.delete(key);
  }
  for (const [key, rawValue] of Object.entries(values).sort(([left], [right]) => left.localeCompare(right))) {
    if (!safeKey(key)) continue;
    const entries = Array.isArray(rawValue) ? rawValue : [rawValue];
    for (const entry of entries) {
      if (entry === null || entry === undefined || entry === "") continue;
      const value = String(entry);
      if (value.length <= 512 && !/[\u0000-\u001f]/.test(value)) params.append(`${prefix}.${key}`, value);
    }
  }
  const query = params.toString();
  const nextHash = `#/${path}${query ? `?${query}` : ""}`;
  if (window.location.hash !== nextHash) window.history.replaceState(window.history.state, "", nextHash);
}
